let page = 2;
const loadMore = {
    fetchHTML(el) {
        const element = $(el);
        const originalText = element.text();
        const url = element.data('url');
        const container = $('.card-image-text__cards-wrapper');
        element.text('a carregar...');
        $.ajax({
            url: url+page,
            dataType: 'html',
            cache: false,
            success: (data,textStatus,request) => {
                if(request.getResponseHeader('next-page')){
                    page = request.getResponseHeader('next-page')
                }
                else{
                    element.remove();
                }
                container.append(data);
            },
            error: (xhr, status, err) => {
                console.error(status, err.toString());
            },
            complete: () => {
                element.text(originalText);
            }
        });
    }
};

